import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialOperatorListState from './operator-list-initial-state';
import { OperatorList } from '../models/operatorList.model';
import { Dayjs } from 'dayjs';

const operatorListSlice = createSlice({
    name: 'operatorListSlice',
    initialState: initialOperatorListState,
    reducers: {
        setOperatorList(state, { payload }: PayloadAction<OperatorList[]>) {
            state.operatorList = payload;
        },
        setCompanies(state, { payload }: PayloadAction<string[]>) {
            state.companies = payload;
        },
        setDepartments(state, { payload }: PayloadAction<string[]>) {
            state.departments = payload;
        },
        setOperators(state, { payload }: PayloadAction<string[]>) {
            state.operators = payload;
        },
        setCreateDate(state, { payload }: PayloadAction<string>) {
            state.dates.startDate = payload;
        },
        setEndDate(state, { payload }: PayloadAction<string>) {
            state.dates.endDate = payload;
        },
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setStartDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.startDate = payload;
        },
        setEndDateDayJS(state, { payload }: PayloadAction<Dayjs>) {
            state.endDate = payload;
        },
    }
});

export const {
    setOperatorList,
    setCompanies,
    setOperators,
    setCreateDate,
    setEndDate,
    setDepartments,
    setShowFilters,
    setStartDateDayJS,
    setEndDateDayJS
} = operatorListSlice.actions

export default operatorListSlice.reducer